import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {Popover} from 'antd';
import {WeaLocaleProvider, WeaTools, WeaBrowser} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

import E8LeftMenuTop4Email from './E8LeftMenuTop4Email';

@inject('portalThemeStore')
@observer
class E8LeftMenuTop extends React.Component {
    constructor(props) {
        super(props);
        this.onVisibleChange = this.onVisibleChange.bind(this);
        this.onOpenCard = this.onOpenCard.bind(this);
        this.onChangeAccount = this.onChangeAccount.bind(this);
    }

    componentWillMount() {
        const {portalThemeStore} = this.props;
        portalThemeStore.getAccount();
    }

    render() {
        const {portalThemeStore} = this.props;
        const {themeInfo, account, accountSize, accountList, accountListVisible, topMenuObj} = portalThemeStore;
        const _account = toJS(account);
        const _accountList = toJS(accountList);

        const {themeData = {}} = themeInfo;
        const {hrmcolor} = themeData;

        const {username = '', deptname = ''} = _account;

        const {topMenuSelected = {}} = topMenuObj;
        const _topMenuSelected = toJS(topMenuSelected);
        const {id:topMenuId, sname:topMenuName} = _topMenuSelected;

        const {userid:curuserid, showSearch} = _account;

        const aclistComp = (
            <div id="e9header-account-content" className="e9header-account-content">
                <div>
                    <div className="e9header-account-title">
                        <span>{getLabel(131608, '主次账号切换')}</span>
                    </div>
                    {
                        showSearch ? (
                            <div className="e9header-account-search">
                                <div className="e9header-account-search-title">
                                    <span>{getLabel(507638, '分部')}</span>
                                </div>
                                <div className="e9header-account-search-browser">
                                    <WeaBrowser
                                        title={getLabel(507638, '分部')}
                                        type={164}
                                        isSingle={true}
                                        tabs={[
                                            {key: '1', name: getLabel(384541, '按组织架构'), selected: false},
                                            {key: '2', name: getLabel(130619, '按列表'), selected: false, dataParams: {list: 1}}
                                        ]}
                                        hasAdvanceSerach={true}
                                        getPopupContainer={() => document.getElementById('e9header-account-content')}
                                        onOpen={() => window.accountListVisible = true}
                                        onClose={() => window.accountListVisible = false}
                                        onChange={id => portalThemeStore.getAccountList(id)}
                                    />
                                </div>
                                <div style={{clear: 'both'}} />
                            </div>
                        ) : ''
                    }
                    <div className="e9header-account-splitter"></div>
                </div>
                <div className="e9header-account-list">
                    {
                        _accountList.map((item, index) => {
                            let {userid, usertype, username, jobs, subcompanyname, deptname} = item;
                            deptname = `${subcompanyname}/${deptname}`;
                            deptname = deptname == '/' ? '' : deptname;

                            return (
                                <div key={index}>
                                    <div className="e9header-account-item">
                                        <div className="e9header-account-item-img" onClick={e => this.onOpenCard(e, userid)}>
                                            <img src={item.icon} alt=""/>
                                        </div>
                                        <div className="e9header-account-item-info"
                                            onClick={e => {
                                                if (userid != curuserid) {
                                                  this.onChangeAccount(userid);
                                                } else {
                                                  this.onOpenCard(e, userid);
                                                }
                                            }}
                                        >
                                            {usertype == '0' && <span className="e9header-account-item-usertype"><i className="icon-coms02-Main-account-number"/></span>}
                                            <span title={username} className="e9header-account-item-username" onClick={e => this.onOpenCard(e, userid)}>{username}</span>
                                            <span title={jobs} className="e9header-account-item-jobs">{jobs}</span>
                                            <br />
                                            <span title={deptname} className="e9header-account-item-deptname">{deptname}</span>
                                        </div>
                                        {userid == curuserid ? <i className="icon-coms02-icon-Completion e9header-account-checked" /> : ''}
                                    </div>
                                    <div className="e9header-account-splitter"></div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );

        return (
            <div className="e8left-lmt">
                <div className="e8left-lmt-hrm" style={hrmcolor ? {backgroundColor: hrmcolor} : {}}>
                    <span className="e8left-lmt-hrm-user" title={username} onClick={() => portalThemeStore.onLoadMain({mobxrouteurl: '/hrm/card/cardInfo'})}>{username}</span>
                    <span className="e8left-lmt-hrm-dept" title={deptname}>{deptname}</span>
                    {
                        accountSize > 1 && (
                            <Popover 
                                trigger="click" 
                                placement="rightTop" 
                                content={aclistComp}
                                overlayClassName="e9header-account-overlay"
                                visible={accountListVisible}
                                onVisibleChange={this.onVisibleChange}
                            >
                                <span className="e8left-lmt-hrm-aclist" title={getLabel(131608, '主次账号切换')}/>
                            </Popover>
                        )
                    }
                </div>
                <div className="e8left-lmt-tmn" style={topMenuId == '536' ? {borderBottom: 'none'} : {}}>
                    <span>{topMenuName}</span>
                </div>
                {topMenuId == '536' ? <E8LeftMenuTop4Email {...this.props} /> : ''}
            </div>
        );
    }

    onVisibleChange(visible) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onAccountListVisibleChange(visible);

        const themeLayoutMask = document.getElementById('themeLayoutMask');
        if (visible) {
            themeLayoutMask.style.display = 'block';
        } else {
            themeLayoutMask.style.display = 'none';
        }
    }

    onOpenCard(e, userid) {
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
        
        const {portalThemeStore} = this.props;
        this.onVisibleChange(false);
        portalThemeStore.onLoadMain({mobxrouteurl: `/hrm/card/cardInfo/${userid}`});
    }

    onChangeAccount(userid) {
        WeaTools.ls.set('isInitLSValue', false);
        window.location.href = `/login/IdentityShift.jsp?shiftid=${userid}`;
    }
}

export default E8LeftMenuTop;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8LeftMenuTop.js